import {Injectable} from "@angular/core";
import {HttpClient, } from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {UiValue} from "../cards/CardStruct";
import {VariableListReceived, VariableValue} from "./VariableValue";
import {variable} from "@angular/compiler/src/output/output_ast";


@Injectable({
  providedIn: 'root'
})

export class VariableDataService {
  private dataUrl: string = "";
  private url: UrlBuilder = new UrlBuilder();

  constructor(private http: HttpClient)
  {
    console.log('Construct VariableDataService');
  }

  Get(refnumber: number): Observable<UiValue> {
    // End result would be some like: "http://192.168.178.200/lly_003_000.json";
    this.dataUrl = this.url.GetUiDataUrl() + "/" + refnumber;
    return this.http.get<UiValue>(this.dataUrl);
  }


  GetDataByPost(valuesToGet: VariableValue[]): Observable<VariableListReceived> {
    let body = " {  \"values\": [ ";

    for(let value of valuesToGet) {
      body += "{";
      body += " \"ref\": " + value.ref + ",";
      body += " \"val\": " + value.ref + "";
      body += "},";
    }
    body += "{";
    body += " \"ref\": " + 0 + ",";
    body += " \"val\": " + 0 + "";
    body += "}";
    body +=      "] }";
    return this.http.post<any>(this.url.GetUiDataUrl()+ "get", body);
  }



}
